import { history } from "redux/configureStore";
import {BASENAME, getPathname, isIntranetPath} from "lib/routing";
import { setCookie, getCookie } from "react-use-cookie";
const defaultHeaders = { "Content-Type": "application/json" }; // expect to receive JSON

export async function doFetch(url, body, method = "POST", headers = defaultHeaders, shouldParseJson = true) {
  const response = await fetch(url, { method, body, headers });
  handleRedirects(response, url); // if receive xhr redirect to login page, redirect win.location
  if (!response.ok) {
    throw new Error(
      "Server error - bad response: " +
        response.status +
        ", " +
        response.statusText +
        "," +
        response.url +
        "," +
        (await tryGetResponseText(response))
    );
  }

  const text = await response.text();
  const json = shouldParseJson ? parseJson(text || "{}", response) : text;

  handleJsonResponses(json, response, url);
  return json;
}

function handleRedirects(response, url) {
  const responseUrl = response.url || "";

  if (isUnauthorizedResponse("", responseUrl, response.status)) {
    onUnauthorized(response, url);
  } else if (responseUrl.includes("/portal/Errors/Detail")) {
    console.error("Server response redirected to an error page", url, responseUrl);
  }
}

function handleJsonResponses(json, response, url) {
  let statusText = (json && json.statusText) || "";

  if (statusText === "Unauthorized") {
    onUnauthorized(response, url);
  } else if (statusText.includes("ChangePassword")) {
    onPasswordChange(statusText, response, json, url);
  }
}

function onUnauthorized(response, url) {
  console.error("Server responded unauthorised for url: " + url, response);
  if (isIntranetPath()) {
    onInternalUnauthorised();
  } else {
    let redirectUrlPath = getPathname()
    let redirectURl= redirectUrlPath + window.location.search + window.location.hash;
    window.location.assign(BASENAME +"/public/login?goto="+ encodeURIComponent(redirectURl));
  }
}

function onPasswordChange(statusText, response, json, url) {
  console.error("Server responded password change: ", statusText, " for url: " + url, response);
  const sid = getSidFromResponse(json);
  if (sid) {
    history.push("/public/change-password?sid=" + sid);
  } else {
    history.push("/public/forgotten-password");
  }
}

function parseJson(text, response, url) {
  try {
    return JSON.parse(text);
  } catch (parseError) {
    const redirected = response.redirected ? "was redirected and" : "";
    console.error("Server error - expected JSON but received:", text);

    if (isUnauthorizedResponse(text)) {
      onUnauthorized(response, url);
    } else {
      throw new Error(
        `Server error - expected JSON but ${redirected} received: [` +
          response.status +
          "-" +
          response.statusText +
          "] from URL: " +
          url +
          "\n " +
          text.substr(0, 500)
      );
    }
  }
}

function isUnauthorizedResponse(text = "", url = "", status = 0) {
  let isUnauthorized =
    status === 401 ||
    text.includes("Nomura Now SSO") ||
    text.includes("You are not Authorized to view this page") ||
    text.includes("sso-core") ||
    url.includes("/portal/User/Login") ||
    url.includes("You%20are%20not%20Authorized");
  return isUnauthorized;
}

function onInternalUnauthorised() {
  const retries = parseInt(getCookie("grp-retries")) || 0;
  if (retries >= 5) {
    history.push("/public/session_expired");
  } else {
    setCookie("grp-retries", retries + 1, { days: 0.1 });
    window.location.assign(BASENAME);
  }
}

async function tryGetResponseText(response) {
  try {
    return await response.text();
  } catch (e) {
    return ""; // ok to swallow
  }
}

export const getSidFromResponse = (json) => {
  try {
    return json.statusText.split("sid=")[1];
  } catch (err) {
    console.error("Could not extract sid token from json response: ", json);
    return "";
  }
};
